import { EventLogState } from './types';

export const state = (): EventLogState => initialState();

export const initialState = (): EventLogState => ({
  allLogEntries: [],
  filteredLogEntries: [],
  currentPageLogEntries: [],
  searchParams: {
    dataOption: {
      page: 1,
      itemsPerPage: 10,
      sortBy: ['dateTime'],
      sortDesc: [true],
      groupBy: [],
      groupDesc: [],
      multiSort: false,
      mustSort: false,
    },
    filter: '',
    orClauseFieldsIds: ['executedByName', 'parsedData'],
  },
  isLoading: false,
});
